//var url = "http://localhost:30475/User/ActionInfo"
// 通信模式
// server-proxy
// access-control
import utils from "../utils";
export default {
  online: {
    system: {
      // host: 'system.jinyantrip.net',
      // proxy: 'test.jinyantrip.net',
      prefix: "system",
    },
    order: {
      // host: 'order.jinyantrip.net',
      // proxy: 'test.jinyantrip.net',
      prefix: "order",
    },
    policy: {
      // host: 'policy.jinyantrip.net',
      // proxy: 'test.jinyantrip.net',
      prefix: "policy",
    },
    bill: {
      // host: 'bill.jinyantrip.net',
      // proxy: 'test.jinyantrip.net',
      prefix: "bill",
    },
    base: {
      // host: 'base.jinyantrip.net',
      // proxy: 'test.jinyantrip.net',
      prefix: "base",
    },
    tour: {
      // host: 'test.ecsapi.jinyantrip.net',
      // proxy: 'localhost:30475',
      prefix: "tour",
    },
    message: {
      // host: 'test.ecsapi.jinyantrip.net',
      // proxy: 'localhost:30475',
      prefix: "message",
    },
    flight: {
      // host: 'test.ecsapi.jinyantrip.net',
      // proxy: 'localhost:30475',
      prefix: "flight",
    },
    tourpolicy: {
      // host: 'test.ecsapi.jinyantrip.net',
      // proxy: 'localhost:30475',
      prefix: "tourpolicy",
    },
    flightpolicy: {
      // host: 'test.ecsapi.jinyantrip.net',
      // proxy: 'localhost:30475',
      prefix: "flightpolicy",
    },
    trainpolicy: {
      // host: 'test.ecsapi.jinyantrip.net',
      // proxy: 'localhost:30475',
      prefix: "trainpolicy",
    },
    hotelpolicy: {
      // host: 'test.ecsapi.jinyantrip.net',
      // proxy: 'localhost:30475',
      prefix: "hotelpolicy",
    },
    train: {
      // host: 'test.ecsapi.jinyantrip.net',
      // proxy: 'localhost:30475',
      prefix: "train",
    },
    hotel: {
      // host: 'test.ecsapi.jinyantrip.net',
      // proxy: 'localhost:30475',
      prefix: "hotel",
    },
    btrip: {
      // host: 'test.ecsapi.jinyantrip.net',
      // proxy: 'localhost:30475',
      prefix: "btrip",
    },
    btrip: {
      // host: 'test.ecsapi.jinyantrip.net',
      // proxy: 'localhost:30475',
      prefix: "btrip",
    },
    work: {
      // host: 'test.ecsapi.jinyantrip.net',
      // proxy: 'localhost:30475',
      prefix: "work",
    },
    insurancepolicy: {
      // host: 'test.ecsapi.jinyantrip.net',
      // proxy: 'localhost:30475',
      prefix: "insurancepolicy",
    },
    fileUrl: {
      host: "images.ecsweb.jinyantrip.net",
      proxy: "images.ecsweb.jinyantrip.net",
      prefix: "",
    },
    chargepolicy: {
      // host: 'test.ecsapi.jinyantrip.net',
      // proxy: 'localhost:30475',
      prefix: "chargepolicy",
    },
    side: {
      prefix: "side",
    },
    admin: {
      prefix: "admin",
    },
    logs: {
      // host: 'test.ecsapi.jinyantrip.net',
      // proxy: 'localhost:30475',
      prefix: "logs",
    },
    storage: {
      // host: 'test.ecsapi.jinyantrip.net',
      // proxy: 'localhost:30475',
      prefix: "storage",
    },
    huilianyi: {
      // host: 'test.ecsapi.jinyantrip.net',
      // proxy: 'localhost:30475',
      prefix: "huilianyi",
    },
  },
  test: {
    system: {
      // host: 'test.ecsapi.jinyantrip.net',
      // proxy: 'localhost:30475',
      prefix: "system",
    },
    order: {
      // host: 'test.ecsapi.jinyantrip.net',
      // proxy: 'localhost:30475',
      prefix: "order",
    },
    policy: {
      // host: 'test.ecsapi.jinyantrip.net',
      // proxy: 'localhost:30475',
      prefix: "policy",
    },
    bill: {
      // host: 'test.ecsapi.jinyantrip.net',
      // proxy: 'localhost:30475',
      prefix: "bill",
    },
    base: {
      // host: 'test.ecsapi.jinyantrip.net',
      // proxy: 'localhost:30475',
      prefix: "base",
    },
    tour: {
      // host: 'test.ecsapi.jinyantrip.net',
      // proxy: 'localhost:30475',
      prefix: "tour",
    },
    message: {
      // host: 'test.ecsapi.jinyantrip.net',
      // proxy: 'localhost:30475',
      prefix: "message",
    },
    flight: {
      // host: 'test.ecsapi.jinyantrip.net',
      // proxy: 'localhost:30475',
      prefix: "flight",
    },
    tourpolicy: {
      // host: 'test.ecsapi.jinyantrip.net',
      // proxy: 'localhost:30475',
      prefix: "tourpolicy",
    },
    flightpolicy: {
      // host: 'test.ecsapi.jinyantrip.net',
      // proxy: 'localhost:30475',
      prefix: "flightpolicy",
    },
    trainpolicy: {
      // host: 'test.ecsapi.jinyantrip.net',
      // proxy: 'localhost:30475',
      prefix: "trainpolicy",
    },
    hotelpolicy: {
      // host: 'test.ecsapi.jinyantrip.net',
      // proxy: 'localhost:30475',
      prefix: "hotelpolicy",
    },
    train: {
      // host: 'test.ecsapi.jinyantrip.net',
      // proxy: 'localhost:30475',
      prefix: "train",
    },
    hotel: {
      // host: 'test.ecsapi.jinyantrip.net',
      // proxy: 'localhost:30475',
      prefix: "hotel",
    },
    btrip: {
      // host: 'test.ecsapi.jinyantrip.net',
      // proxy: 'localhost:30475',
      prefix: "btrip",
    },
    fileUrl: {
      host: "images.ecsweb.jinyantrip.net",
      proxy: "images.ecsweb.jinyantrip.net",
      prefix: "",
    },
    work: {
      // host: 'test.ecsapi.jinyantrip.net',
      // proxy: 'localhost:30475',
      prefix: "work",
    },
    insurancepolicy: {
      // host: 'test.ecsapi.jinyantrip.net',
      // proxy: 'localhost:30475',
      prefix: "insurancepolicy",
    },
    chargepolicy: {
      // host: 'test.ecsapi.jinyantrip.net',
      // proxy: 'localhost:30475',
      prefix: "chargepolicy",
    },
    side: {
      prefix: "side",
    },
    admin: {
      prefix: "admin",
    },
    logs: {
      // host: 'test.ecsapi.jinyantrip.net',
      // proxy: 'localhost:30475',
      prefix: "logs",
    },
    storage: {
      // host: 'test.ecsapi.jinyantrip.net',
      // proxy: 'localhost:30475',
      prefix: "storage",
    },
    adapter: {
      prefix: "adapter",
    },
    huilianyi: {
      // host: 'test.ecsapi.jinyantrip.net',
      // proxy: 'localhost:30475',
      prefix: "huilianyi",
    },
  },
  isOnline: false,
  isHttps: false,
  isProxy: false,
  getUrl(name, url) {
    var apicfg = this[this.isOnline ? "online" : "test"][name];
    var host = apicfg[this.isProxy ? "proxy" : "host"];
    var protocol = host ? (this.isHttps ? "https" : "http") : "/api";
    if (host) {
      return protocol.concat(
        "://",
        host,
        apicfg["prefix"] ? "/" : "",
        apicfg["prefix"],
        utils.startWith(url, "/") ? "" : "/",
        url
      );
    } else {
      return protocol.concat(
        "/",
        apicfg["prefix"],
        utils.startWith(url, "/") ? "" : "/",
        url
      );
    }
  },
};



// WEBPACK FOOTER //
// ./src/apis/config.js